import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=54c5e55e&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=54c5e55e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c5e55e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54c5e55e')) {
      api.createRecord('54c5e55e', component.options)
    } else {
      api.reload('54c5e55e', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=54c5e55e&scoped=true&", function () {
      api.rerender('54c5e55e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2uX3tMhbT2X9V/JS/comp/PopupBox.vue"
export default component.exports